<form [formGroup]="form" #formDirective="ngForm">
  <div class="row">
    <div class="mt-3 col-4">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Categoria</mat-label>
        <mat-select formControlName="categoria" [compareWith]="compareEnumCategoria">
          <mat-option [value]="''">Selecione uma opção</mat-option>
          <mat-option *ngFor="let categoria of (categorias$ | async)" [value]="categoria">{{categoria}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="mt-3 col-8">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Função</mat-label>
        <input
              #funcaoSelecaoInputFuncao
              type="text"
              placeholder=""
              aria-label="Função"
              matInput
              formControlName="funcao"
              [matAutocomplete]="auto"
              cdkFocusInitial>
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selecionarFuncao($event)">
          <mat-option *ngFor="let option of funcoesFiltradasNaoAdicionadas$ | async" [value]="option.nome">
            {{option.nome}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>
</form>
